/* eslint-disable complexity */
import isEmpty from 'lodash/isEmpty';
import Confetti from 'react-confetti';
import React, { useRef, useEffect, useState } from 'react';
import { getBrand } from '@tcp/core/src/utils/utils';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import balloon from './shapes/balloon';
import circle from './shapes/circle';
import gift from './shapes/gift';
import heart from './shapes/heart';
import snow from './shapes/snow';
import square from './shapes/square';
import star from './shapes/star';
import defaultShape from './shapes/default';
import styles from './Confetti.style';

const shapeMap = {
  balloon,
  circle,
  gift,
  heart,
  snow,
  square,
  star,
};

const defaultColors = [
  '#f44336',
  '#e91e63',
  '#9c27b0',
  '#673ab7',
  '#3f51b5',
  '#2196f3',
  '#03a9f4',
  '#00bcd4',
  '#009688',
  '#4CAF50',
  '#8BC34A',
  '#CDDC39',
  '#FFEB3B',
  '#FFC107',
  '#FF9800',
  '#FF5722',
  '#795548',
];

const getColorVal = (color) => (isEmpty(color) ? defaultColors : color);

const ConfettiCelebration = ({
  duration = 100000,
  shape = '',
  size = 20,
  numberOfPieces = 500,
  path,
  routerPath,
  className,
  color,
}) => {
  const brandName = getBrand();
  const SESSION_KEY = `${brandName}-confetti-config`;
  const animationFrameRef = useRef();
  const [windowDimensions, setWindowDimensions] = useState({ width: 0, height: 0 });
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    const updateDimensions = () => {
      animationFrameRef.current = requestAnimationFrame(() => {
        setWindowDimensions({
          width: window.innerWidth,
          height: Math.max(
            document.documentElement.scrollHeight,
            document.body.scrollHeight,
            window.innerHeight
          ),
        });
      });
    };

    updateDimensions();
    window.addEventListener('resize', updateDimensions);

    return () => {
      if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  useEffect(() => {
    let timeout;
    try {
      const confettiConfig = sessionStorage.getItem(SESSION_KEY);
      const parsedConfettiConfig = confettiConfig ? JSON.parse(confettiConfig) : {};
      // Clean the pathToCheck by removing query parameters
      const url = new URL(routerPath, window.location.origin);
      const pathToCheck = url.pathname.split('/').pop() || '';
      const pathArray = path.split(',').map((item) => item.trim());
      const shouldShow = pathArray.includes(pathToCheck);
      const hasShownOnPath = parsedConfettiConfig[pathToCheck];
      if (!hasShownOnPath && shouldShow) {
        setShowConfetti(true);
        parsedConfettiConfig[pathToCheck] = true;
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(parsedConfettiConfig));
        timeout = setTimeout(() => setShowConfetti(false), duration);
      } else {
        setShowConfetti(false);
      }
    } catch (error) {
      console.error('Error parsing confetti configuration:', error);
    }

    return () => clearTimeout(timeout);
  }, [routerPath]);

  const drawShape = (ctx) => {
    const colorVal = getColorVal(color);
    const draw = shapeMap[shape] || defaultShape;
    draw(ctx, size, colorVal, !isEmpty(color));
  };

  return showConfetti ? (
    <div className={`${className} confetti`} key={`${routerPath}`}>
      <Confetti
        width={windowDimensions.width}
        height={windowDimensions.height}
        numberOfPieces={numberOfPieces}
        recycle={false}
        drawShape={(ctx) => drawShape(ctx)}
        class="confetti-canvas"
      />
    </div>
  ) : null;
};

export { ConfettiCelebration as ConfettiCelebrationVanilla };
export default withStyles(ConfettiCelebration, styles);
